import { useEffect, useState } from "react";

import { cn } from "@roman/shared/utils";
import { getPlatform } from "@roman/shared/utils/platform";
import { XIcon } from "lucide-react";

export const APPSTORE_URL = "https://apps.apple.com/jp/app/id6748591967";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=jp.thumba.app";

export const MobileAppBanner = () => {
  const [isOpen, setIsOpen] = useState(false);

  const platform = getPlatform();
  const delay = platform === "ios" || platform === "android" ? 2000 : 3000;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleButtonClick = () => {
    // Redirect to app store
    if (platform === "ios") {
      window.location.href = APPSTORE_URL;
    } else if (platform === "android") {
      window.location.href = GOOGLE_PLAY_URL;
    }
  };

  // iOSはApple Smart BannerおよびApple App Site Associationで対応 出来次第、コメントアウトを戻す
  // const isSafari = platform === "ios" && navigator.userAgent.includes("Safari");
  // if (isSafari) {
  //   return null;
  // }

  return (
    <div
      className={cn(
        "flex justify-between items-center border border-[#E7EBEE]",
        "w-full max-w-[770px] md:rounded-[10px]",
        "transition-all duration-300 ease-in-out",
        platform === "ios"
          ? "bg-black"
          : platform === "android"
            ? "bg-[#202124]"
            : "bg-white [box-shadow:0px_0px_20px_rgba(0,0,0,0.05)] rounded-[10px] mt-[14px]",
        isOpen ? "translate-y-0 h-[90px] p-[14px] mb-[14px]" : "-translate-y-full h-0 opacity-0 p-0 mb-0",
      )}
    >
      {/* App info section */}
      <div className="flex justify-center items-center">
        <button
          type="button"
          onClick={handleClose}
          className="flex items-center justify-center mr-[10px] hover:opacity-70 transition-opacity"
          aria-label="Close banner"
        >
          <XIcon className="h-[12px] w-[12px] text-[#4C4C4F]" />
        </button>
        {platform === "android" ? (
          <img src="/assets/miraima-app-android.png" alt="logo" className="h-[62px]" />
        ) : (
          <img src="/assets/miraima-app-pc.png" alt="logo" className="h-[70px]" />
        )}

        <div className="flex flex-col items-start ml-[10px]">
          <p
            className={cn(
              "text-white text-[16px] font-inter font-regular",
              platform === "ios" || platform === "android" ? "text-white" : "text-black",
            )}
          >
            MIRAIMA
          </p>
          <p className="text-[#909096] text-[12px]">未来予想でポイント貯まる</p>
        </div>
      </div>

      {/* Get button for android */}
      {platform === "android" && (
        <button
          type="button"
          className={cn("flex items-center px-[24px] h-[30px]", "bg-[#00A173] text-black hover:bg-[#006B4C]")}
          onClick={handleButtonClick}
        >
          <p className={cn("text-sm text-white font-semibold font-inter", "text-white")}>{"Get"}</p>
        </button>
      )}

      {/* App store badges for PC */}
      {platform === "pc" && (
        <div className="flex items-center gap-[8px]">
          <a
            href={APPSTORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity"
          >
            <img src="/assets/appstore-black.svg" alt="App Store" className="h-[40px]" />
          </a>
          <a
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity"
          >
            <img src="/assets/playstore-black.svg" alt="Google Play" className="h-[40px]" />
          </a>
        </div>
      )}
    </div>
  );
};
